import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 17.2953V6.70692C6 4.84173 6 3.90913 6.39081 3.3796C6.73153 2.91795 7.25412 2.62486 7.82571 2.57486C8.48133 2.51751 9.2771 3.00381 10.8686 3.97642L19.5319 9.27064C21.0092 10.1734 21.7478 10.6248 21.9997 11.2059C22.2195 11.7132 22.2195 12.289 21.9997 12.7963C21.7478 13.3774 21.0092 13.8288 19.5319 14.7316L10.8686 20.0258C9.2771 20.9984 8.48133 21.4847 7.82571 21.4274C7.25412 21.3774 6.73153 21.0843 6.39081 20.6226C6 20.0931 6 19.1605 6 17.2953Z",
		stroke: "#EFEEF0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPlayIcon;
